import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import FileInput from "../Inpsuts/FileInput";

import { IAMAxios } from "../../../../API";

const UploadFile = () => {
  const [show, setShow] = React.useState(false);
  const [disableSubmit, setDisableSubmit] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [filename, setFilename] = React.useState("Choose File");
  const [uploadSuccess, setUploadSuccess] = React.useState(false);

  useEffect(() => {
    if (file) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [file]);

  const onChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
      setFilename(e.target.files[0].name);
    }
  };

  const uploadFile = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);

    IAMAxios.post("/SAPUser/importsapdata", formData)
      .then((response) => {
        console.log("File upload ", response);
        setUploadSuccess(true);
        setFile(null);
        setFilename("Choose File"); // reset filename
        // setShow(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Button onClick={() => setShow(true)}>
        <i className="fa fa-upload me-2"></i>
        Import Data
      </Button>
      <Modal show={show} 
      dialogClassName="upload-modal"
      centered>
        <form onSubmit={uploadFile}>
          <Modal.Header>
            <Modal.Title>Import Data</Modal.Title>

            <div className="close" onClick={() => setShow(false)}>
              <span aria-hidden="true">&times;</span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-2">
              <FileInput
                required={true}
                label="Choose File"
                filename={filename}
                onChange={onChange}
              />
            </div>
            {uploadSuccess && (
              <div className="alert alert-success">
                File Uploaded Successfully
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn-text"
              variant="link"
              onClick={() => setShow(false)}
            >
              Close
            </Button>
            <Button variant="primary" type="submit" disabled={disableSubmit}>
              Upload
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default UploadFile;
